export default {
  "settingsTargetSaved": "Obiettivo salvato",
  "settingsVisual0": "Configurare assegnazioni, obiettivi, attività e sequenze per ogni fase salvata.",
  "settingsVisual1": "Definire le fasi, i colori e i risultati della pipeline.",
  "settingsVisual2": "Denomina ogni fase e scegli il suo colore e il suo risultato.",
  "settingsVisual3": "Colore",
  "settingsVisual4": "Colore personalizzato",
  "settingsVisual5": "fasi",
  "settingsVisual6": "Inserire i nomi delle fasi per vedere l'anteprima della pipeline.",
  "settingsVisual7": "Tutte le modifiche salvate",
  "settingsVisual8": "Organizza il tuo processo di vendita in fasi chiare.",
  "settingsVisual9": "Impostare un obiettivo misurabile per la vostra squadra.",
  "settingsVisual10": "Salva i tuoi cambiamenti?",
  "settingsVisual11": "Tutti i compiti del team, incluso il lavoro non assegnato.",
  "settingsVisual12": "Solo i compiti assegnati a se stessi.",
  "settingsVisual13": "Responsabili: tutti i compiti del team. I venditori: solo i propri compiti. Compiti non assegnati: solo manager.",
  "settingsVisual14": "Predefiniti di accesso e assegnazione",
  "settingsVisual15": "I compiti non assegnati sono visibili solo ai manager.",
  "settingsVisual16": "Impostare l'assegnazione di default e rivedere l'accesso dal ruolo CRM.",
  "settingsVisual17": "Anteprima dell'assegnazione",
  "settingsVisual18": "Regole illustrative soltanto — non lavoro vivo.",
  "settingsVisual19": "Creatore di attività idonea",
  "settingsVisual20": "Proprietario di lead idoneo",
  "settingsVisual21": "Il Creatore non è idoneo",
  "settingsVisual22": "Il proprietario del lead non è idoneo",
  "settingsVisual23": "Membro del personale",
  "settingsVisual24": "L'accesso alle attività rimane lo stesso.",
  "settingsVisual25": "Avrà accesso a tutte le attività del team.",
  "settingsVisual26": "Vedranno solo i loro compiti assegnati.",
  "settingsVisual27": "{count} personale selezionato",
  "settingsVisual28": "Personale attivo",
  "settingsVisual29": "Selezione",
  "settingsVisual30": "Dipartimento · Titolo di lavoro",
  "settingsVisual31": "Già nel team di vendita",
  "settingsVisual32": "Rimuovi la selezione",
  "settingsVisual33": "Scegli il tuo team",
  "settingsVisual34": "Selezionare il personale a sinistra per rivedere i loro ruoli qui.",
  "settingsVisual35": "L'accesso CRM verrà rimosso",
  "settingsVisual36": "La proprietà del lead è separata dall'assegnazione del compito.",
  "settingsVisual37": "Lavorare per riassegnare",
  "settingsVisual38": "Nessun lavoro aperto per riassegnare",
  "settingsVisual39": "La storia completa resta con questo membro del personale. Solo il lavoro aperto può essere trasferito.",
  "settingsVisual40": "Trasferimento di proprietà",
  "settingsVisual41": "Attività aperte",
  "settingsVisual42": "Indicazioni attive",
  "settingsVisual43": "Nessun lavoro aperto da trasferire in questa sezione.",
  "settingsVisual44": "Pronto a rimuovere l'adesione. La storia è conservata.",
  "settingsVisual45": "Scegliere le destinazioni per tutti i lavori aperti per continuare.",
  "settingsVisual46": "Aggiungi il personale al team di vendita",
  "settingsVisual47": "Scegli i membri dello staff esistenti e assegna il loro ruolo di CRM.",
  "settingsVisual48": "Verificare l'accesso e trasferire il lavoro aperto prima di rimuovere l'adesione.",
  "settingsVisual49": "Trasferire i compiti aperti e i lead attivi preservando la storia completata.",
  "selectALeadToSeeAIInsightsAndSuggestions": "Seleziona un vantaggio per vedere le informazioni e i suggerimenti dell'IA",
  "aIInsights": "Analisi IA",
  "suggestedActions": "Azioni consigliate:",
  "confidence": "Confidenza:",
  "noActiveInsightsForThisLead": "Nessuna intuizione attiva per questo vantaggio",
  "suggestedNextSteps": "Prossimo passo consigliato",
  "timeline": "Linea temporale:",
  "aIEmailAssistant": "Assistente e-mail IA",
  "tone": "Tono:",
  "professional": "Professionista",
  "friendly": "Amichevole",
  "formal": "Formale",
  "casual": "Casuale",
  "generatedDraft": "Progetto Generato:",
  "sendEmail": "Invia email",
  "copyToClipboard": "Copia a Appunti",
  "briefSummaryOfLeadSJourneyAndStatus": "Breve sintesi del viaggio e dello stato del lead",
  "mainTopicsDiscussedSoFar": "Argomenti principali discussi finora",
  "questionsToAskInNextInteraction": "Domande da porre nella prossima interazione",
  "recommendedNextStep": "Prossimo passo consigliato",
  "thingsToWatchOutForOrLeverage": "Cose da vedere o da levare",
  "aIContactAssistant": "Assistente contatti IA",
  "analyzing": "Analizzando...",
  "insights": "Approfondimenti",
  "lastUpdated": "Ultimo aggiornamento:",
  "clickGenerateInsightsToGetAIPoweredLeadAnalysis": "Fare clic su \"Insights Generate\" per ottenere l'analisi di lead alimentata da AI",
  "analyzingLeadDataAndGeneratingInsights": "Analizzare i dati di lead e generare intuizioni...",
  "leadSummary": "Sommario del lead",
  "keyDiscussionTopics": "Argomenti di discussione chiave",
  "suggestedQuestions": "Domande suggerite",
  "q": "Q",
  "recommendedNextAction": "Prossima azione",
  "importantNotes": "Note importanti",
  "failedToLoadLeads": "Non caricate i cavi",
  "leadsUpdated": "lead aggiornato",
  "failedToAddLeadsToPipeline": "Non è stato possibile aggiungere i cavi al gasdotto",
  "allLeads": "Tutti i lead",
  "searchFilterAndManageLeadsAcrossAllPipelines": "Ricerca, filtrare e gestire i cavi attraverso tutte le tubazioni.",
  "searchLeadsByNameOrEmail": "Ricerca conduce per nome o e-mail",
  "allPipelines": "Tutte le tubazioni",
  "noPipelineAssigned": "Nessuna pipeline assegnata",
  "lead": "Lead",
  "phone": "Telefono",
  "source": "Fonte",
  "pipeline": "Pipeline commerciale",
  "stage": "Fase",
  "statusTemp": "Stato / Temp",
  "lastActivity": "Ultima attività",
  "created": "Creato",
  "noLeadsFound": "Nessun indizio trovato.",
  "page": "Pagina",
  "of": "di",
  "previous": "Precedente",
  "next": "Avanti",
  "leadSSelected": "lead(s) selezionato",
  "clearSelection": "Selezione chiara",
  "addToPipeline": "Aggiungi a Pipeline",
  "selectAPipelineToMoveTheSelectedLeadsIntoTheFirstStage": "Selezionare una pipeline per spostare i lead selezionati nella prima fase.",
  "chooseAPipeline": "Scegli una pipeline",
  "cancel": "Annulla",
  "confirm": "Conferma",
  "cRMAnalytics": "Analisi CRM",
  "last7Days": "Ultimi 7 giorni",
  "last30Days": "Ultimi 30 giorni",
  "last90Days": "Ultimo 90 giorni",
  "pipelineValue": "Valore della tubatura",
  "activeDeals": "Offerte attive",
  "winRate": "Tasso di vincita",
  "avgDealSize": "Avg. Taglia di affare",
  "activeLeads": "lead attivo",
  "conversionRate": "Tasso di conversione",
  "target": "Obiettivo",
  "failedToLoadCRMSummary": "Non è riuscito a caricare il riepilogo CRM.",
  "pipelineDistribution": "Distribuzione del tubo",
  "activityTrends": "Tendenze di attività",
  "leadSourcePerformance": "Prestazioni della fonte di lead",
  "dealHealthOverview": "Panoramica sulla salute",
  "healthyActive": "Salute (Attivo)",
  "stale14Weeks": "Stale (1-4 settimane)",
  "atRisk30Days": "Al Rischio (30+ giorni)",
  "dealsNeedImmediateAttention": "offerte bisogno di immediata attenzione",
  "pipelineVelocityAvgDaysInStage": "Pipeline Velocity (Avg. Giorni in Fase)",
  "avgDays": "Avg. Giorni",
  "status": "Stato",
  "selectAPipelineToViewLeads": "Selezionare una pipeline per visualizzare i lead.",
  "failedToLoadLeadList": "Non è riuscito a caricare la lista di lead.",
  "loadingLeads": "Caricamento in corso...",
  "name": "Nome",
  "company": "Società",
  "contact": "Contatto",
  "priority": "Priorità",
  "value": "Valore",
  "assignedTo": "Assegnato a",
  "actions": "Azioni",
  "noLeadsFoundForThisPipeline": "Nessun indizio trovato per questo gasdotto.",
  "loadingPipeline": "Conduttura di carico...",
  "unableToDetermineClubContext": "Incapace di determinare il contesto del club.",
  "noCRMPipelinesConfiguredYet": "Non sono ancora configurate le tubazioni CRM.",
  "selectAPipelineToViewStages": "Selezionare una pipeline per visualizzare le fasi.",
  "failedToLoadPipelineData": "Non è riuscito a caricare i dati della pipeline.",
  "followUp": "Seguito:",
  "email": "E-mail",
  "sMS": "SMS",
  "call": "Chiama",
  "noLeadsInThisStage": "Non c'è traccia in questa fase",
  "selectSalesTeamMember": "Seleziona membro del team di vendita",
  "stageGoalsCanTBeSetOnTheFinalNonTerminalStage": "Gli obiettivi della fase non possono essere fissati sulla fase finale non-terminal.",
  "taskType": "Tipo di attività",
  "taskName": "Nome dell'attività",
  "taskNote": "Nota di attività",
  "selectActiveSequence": "Selezionare la sequenza attiva",
  "remove": "Rimuovi",
  "save": "Salva",
  "userAssignments": "Assegnazioni dell'utente",
  "stageGoals": "Obiettivi di Fase",
  "tasks": "Compiti",
  "sequences": "Sequenze",
  "editPipeline": "Modifica della Pipeline",
  "pipelineName": "Nome della tubatura",
  "loadingStages": "Stadi di carico...",
  "addStage": "Aggiungere la fase",
  "deletePipeline": "Eliminare la pipeline",
  "pipelines": "Pipeline commerciali",
  "loadingPipelines": "Caricamento delle tubature...",
  "stages": "Fasi",
  "sortOrder": "Ordinare",
  "edit": "Modifica",
  "createPipeline": "Creare Pipeline",
  "loadingTarget": "Obiettivo di caricamento...",
  "label": "Etichetta",
  "annualMemberSignUps": "Firma annuale dei soci",
  "goal": "Gol",
  "period": "Periodo",
  "annual": "Annuale",
  "quarterly": "Trimestrale",
  "monthly": "Mensile",
  "saveTarget": "Risparmio di destinazione",
  "saved": "Salvata.",
  "weeklyActivities": "Attività settimanali",
  "updated": "Aggiornato:",
  "use": "Uso",
  "pleaseEnterAnAIPromptFirst": "Si prega di inserire un prompt AI prima",
  "errorGeneratingContent": "Contenuto di generazione di errori",
  "templateName": "Nome del modello",
  "templateName2": "Nome modello...",
  "type": "Tipo",
  "sharing": "Condividere",
  "private": "Privato",
  "team": "Squadra",
  "organization": "Organizzazione",
  "subject": "Oggetto",
  "emailSubject": "Oggetto e-mail...",
  "category": "Categoria",
  "categoryOptional": "Categoria (opzionale)...",
  "aIContentAssistant": "Assistente contenuti IA",
  "eGAFriendlyFollowUpAfterADemo": "ad esempio, un follow-up amichevole dopo una demo...",
  "generate": "Generazione",
  "content": "Contenuto",
  "templateContentUseLeadFirstNameForMergeFields": "Contenuto del modello... Utilizzare {{lead.firstName}} per unire i campi",
  "insertField": "Inserisca il campo:",
  "leadFirstName": "lead.firstName",
  "leadLastName": "lead.lastName",
  "leadCompany": "azienda principale.",
  "senderName": "mittente.",
  "saveTemplate": "Salva il modello",
  "failedToLoadTemplates": "Non caricare i modelli",
  "errorSavingTemplate": "Modello di risparmio di errore",
  "templateDuplicated": "Template duplicato",
  "errorDuplicatingTemplate": "Modello di duplicazione di errore",
  "templateArchived": "Template archiviato",
  "errorArchivingTemplate": "Modello di archiviazione errori",
  "emailTemplates": "Modelli e-mail",
  "createAndManageReusableTemplates": "Creare e gestire modelli riutilizzabili",
  "createTemplate": "Crea il modello",
  "searchTemplates": "Modelli di ricerca...",
  "allTypes": "Tutti i tipi",
  "loadingTemplates": "Caricamento di modelli...",
  "noTemplatesFound": "Nessun modello trovato",
  "createYourFirstTemplate": "Crea il tuo primo modello",
  "qualified": "Qualifica",
  "contactMade": "Contatto Made",
  "tourScheduled": "Tour programmato",
  "tourCompleted": "Tour completato",
  "proposalSent": "Proposta di decisione",
  "negotiating": "Negoziare",
  "closedWon": "Vinto chiuso",
  "closedLost": "Chiuso perso",
  "low": "Basso",
  "medium": "Medio",
  "high": "Alto",
  "hot": "Caldo",
  "setPriority": "Impostare la priorità",
  "setStage": "Set di fasi",
  "overview": "Panoramica",
  "activities": "AttivitÃ (",
  "aIAssistant": "Assistente IA",
  "notesTasks": "Note e attività",
  "contactInformation": "Informazioni di contatto",
  "logActivity": "Attività di log",
  "convertToMember": "Converti in socio",
  "convertedToMember": "Convertito in socio",
  "leadDetails": "Dettagli di lead",
  "referringMember": "socio di riferimento",
  "membershipInterest": "Interessi degli Stati soci",
  "timelineDates": "Timeline & Date",
  "nextFollowUp": "Prossimo follow-up",
  "tourDate": "Data del tour",
  "notes": "Note",
  "activityTimeline": "Attività Timeline",
  "noActivitiesRecordedYet": "Nessuna attività registrata",
  "addNote": "Aggiungi nota",
  "noNotesOrTasksYet": "Nessuna nota o attività",
  "advancedFilters": "Filtri avanzati",
  "filterLeads": "Filtro di lead",
  "clearAll": "Cancella tutto",
  "dateAdded": "Data aggiunta",
  "allStaffMembers": "Tutti i membri del personale",
  "leadSource": "Fonte di lead",
  "allSources": "Tutte le fonti",
  "pipelineStage": "Fase di tubatura",
  "allStages": "Tutte le fasi",
  "allPriorities": "Tutte le priorità",
  "pipelineType": "Tipo di tubo",
  "allPipelines2": "Tutte le tubature",
  "membership": "Iscrizione",
  "corporate": "Corporate corporate",
  "event": "Evento",
  "referral": "Rinvio",
  "estimatedValueRange": "Gamma di valore stimata",
  "min": "Min.",
  "to": "a",
  "max": "Max.",
  "sourceEvent": "Evento sorgente",
  "allEvents": "Tutti gli eventi",
  "applyFilters": "Applicare filtri",
  "pleaseSelectACountryCode": "Si prega di selezionare un codice paese.",
  "pleaseEnterAPhoneNumber": "Si prega di inserire un numero di telefono.",
  "enterAValidPhoneNumberBetween8And15Digits": "Inserisci un numero di telefono valido tra 8 e 15 cifre.",
  "firstName": "Primo nome *",
  "lastName": "Ultimo nome *",
  "countryCode": "Codice paese",
  "allCountries": "Tutti i paesi",
  "phoneNumber": "Numero di telefono",
  "pipeline2": "Pipeline commerciale *",
  "selectPipeline": "Selezionare la pipeline",
  "stage2": "Fase *",
  "selectStage": "Selezionare la fase",
  "source2": "Fonte *",
  "selectSource": "Selezionare la sorgente",
  "website": "Sito web",
  "advertising": "Pubblicità",
  "socialMedia": "Social media",
  "coldOutreach": "Elevazione a freddo",
  "other": "Altro",
  "membershipTypeInterest": "Tipo di interesse",
  "selectType": "Selezionare il tipo",
  "selectPriority": "Selezionare la priorità",
  "leadValue": "Valore di lead",
  "unassigned": "Non assegnato",
  "interests": "Interessi",
  "addInterestGolfTennisDiningEtc": "Aggiungi interesse (golf, tennis, pranzo, ecc.)",
  "add": "Aggiungi",
  "tags": "Tag",
  "addTag": "Aggiungi il tag",
  "connections": "Collegamenti",
  "saveLeadFirstToAddConnections": "Salvare il lead prima per aggiungere connessioni.",
  "connectionType": "Tipo di connessione",
  "member": "Socio",
  "search": "Cerca",
  "select": "Seleziona",
  "note": "Nota",
  "describeTheRelationship": "Descrivi il rapporto",
  "addConnection": "Aggiungi connessione",
  "noConnections": "Nessuna connessione",
  "leadSourceAnalytics": "Analisi delle fonti di lead",
  "refreshData": "Dati di aggiornamento",
  "totalSources": "Fonti totali",
  "bestConversion": "Migliore conversione",
  "topSource": "Fonte principale",
  "sourcePerformance": "Prestazioni di origine",
  "conversionRatesBySource": "Tassi di conversione per Sorgente",
  "leadGenerationTrendsLast30Days": "Lead Generation Trends (ultimi 30 giorni)",
  "detailedSourcePerformance": "Prestazioni di origine dettagliate",
  "totalLeads": "Totale lead",
  "avgValue": "Avg. Valore",
  "totalValue": "Valore totale",
  "performance": "Prestazioni",
  "interest": "Interessi",
  "interestedIn": "Interessato a:",
  "projectedValue": "Valore proiettato:",
  "leadToMember": "Portare a socio",
  "aNewMemberJoinsTheClub": "Un nuovo socio si unisce al Club",
  "hasReachedClosedWonWouldYouLikeToOfficiallyCreateTheirMemberProfile": "ha raggiunto Closed Won. Vuoi creare ufficialmente il loro profilo?",
  "keepInClosedWon": "Mantenere in Vinto chiuso",
  "followUp2": "Seguito",
  "noFollowUp": "Nessun follow-up",
  "noActiveLeadsFound": "Nessun comando attivo trovato",
  "logActivityFor": "Attività di log per",
  "activityType": "Tipo di attività",
  "meeting": "Riunione",
  "tour": "Tour tour",
  "outcome": "Risultato",
  "selectOutcome": "Selezionare il risultato",
  "positive": "Positivo",
  "neutral": "Neutrale",
  "negative": "Negativo",
  "noResponse": "Nessuna risposta",
  "titleSubject": "Titolo / Oggetto",
  "description": "Descrizione",
  "sent": "Inviato",
  "openRate": "Tariffe aperte",
  "clickRate": "Clicca sulla tariffa",
  "bounced": "Rimbalzo",
  "scheduled": "Programmato:",
  "created2": "Creato:",
  "recipients": "Destinatari:",
  "audience": "Udienza",
  "schedule": "Calendario",
  "campaignTitle": "Titolo della campagna",
  "internalCampaignName": "Nome della campagna interna",
  "campaignType": "Tipo di campagna",
  "broadcast": "Trasmissione",
  "dripCampaign": "Campagna di goccia",
  "leadNurture": "Nurture di lead",
  "subjectLine": "Oggetto",
  "emailSubjectLine": "Linea dell'oggetto e-mail",
  "previewText": "Testo dell'anteprima",
  "textShownInEmailPreview": "Testo mostrato in anteprima e-mail",
  "fromName": "Dal nome",
  "replyToEmail": "Rispondi a E-mail",
  "repliesYourclubCom": "replies@yourclub.com",
  "emailContent": "Contenuto e-mail",
  "emailHTMLContent": "Contenuto HTML e-mail...",
  "forPersonalization": "per personalizzazione",
  "targetAudience": "Udienza di destinazione",
  "selectedFiltersWillTarget": "I filtri selezionati saranno indirizzati",
  "leads": "guida",
  "leadStages": "Fasi di lead",
  "leadSources": "Fonti di lead",
  "priorityLevel": "Livello di priorità",
  "sendTimeOptional": "Tempo di invio (opzionale)",
  "leaveBlankToSendImmediately": "Lasciare vuoto per inviare immediatamente",
  "loadingCampaigns": "Caricamento di campagne...",
  "marketingCampaigns": "Campagne di marketing",
  "createAndManageEmailCampaignsForYourLeads": "Creare e gestire campagne e-mail per i tuoi lead",
  "createCampaign": "Creare una campagna",
  "noCampaignsYet": "Nessuna campagna ancora",
  "createYourFirstEmailCampaignToStartNurturingLeads": "Crea la tua prima campagna e-mail per iniziare a nutrire i lead",
  "createFirstCampaign": "Creare la prima campagna",
  "campaignAnalytics": "Analitica della campagna -",
  "opened": "Aperto",
  "clicked": "Cliccato",
  "close": "Chiudi",
  "failedToLoadProspects": "Non è riuscito a caricare prospettive",
  "addedToCRM": "Aggiunto a CRM",
  "failedToAddProspectsToCRM": "Non è riuscito ad aggiungere prospettive al CRM",
  "undoComplete": "Annullamento completato",
  "failedToUndoLastImport": "Non è riuscito a annullare l'ultima importazione",
  "prospects": "Prospetti",
  "searchVisitorsAndAddThemToYourCRMPipeline": "Cerca i visitatori e aggiungili alla tua pipeline CRM.",
  "searchProspectsByNameOrEmail": "Prospettive di ricerca per nome o e-mail",
  "undoLastImport": "Annullare l'ultima importazione",
  "addToCRM": "Aggiungi a CRM",
  "lastVisit": "Ultima visita",
  "totalVisits": "Visite totali",
  "noProspectsFoundYet": "Ancora nessuna prospettiva trovata.",
  "salesRep": "Reparto di vendita",
  "salesManager": "Responsabile vendite",
  "failedToLoadSalesTeam": "Non è riuscito a caricare il team di vendita",
  "failedToLoadStaff": "Non caricate il personale",
  "salesTeamMemberAdded": "Componente del team di vendita aggiunto",
  "addFailed": "Aggiungi il guasto",
  "updateFailed": "Aggiornamento fallito",
  "memberRemoved": "Rimozione dei soci",
  "removeFailed": "Rimuovere il mancato",
  "salesTeam": "Team di vendita",
  "controlWhoCanBeAssignedCRMTasks": "Controllare chi può essere assegnato compiti CRM.",
  "addTeamMember": "Aggiungi membro del team",
  "teamMembers": "Membri del gruppo",
  "loadingSalesTeam": "Caricamento del team di vendita...",
  "noSalesTeamMembersYet": "Nessun membro del team di vendita ancora.",
  "staff": "Personale",
  "jobTitle": "Titolo del lavoro",
  "role": "Ruolo",
  "searchStaff": "Ricerca personale",
  "searchByNameEmailTitle": "Ricerca per nome, e-mail, titolo",
  "selectAStaffMember": "Seleziona un membro del personale",
  "selectAStepToEditItsProperties": "Seleziona un passaggio per modificare le sue proprietà",
  "onReplyActionS": "Su Azione di risposta(i)",
  "createTask": "Creare attività",
  "advanceStage": "Fase di promozione",
  "title": "Titolo",
  "taskTitle": "Titolo dell'attività",
  "normal": "Normale",
  "assignee": "Assegnatario",
  "movesTheLeadToTheNextStageBySortOrder": "Sposta il lead alla fase successiva per ordine ordinario.",
  "emailTemplate": "Template e-mail",
  "selectTemplate": "Selezionare il modello...",
  "templateIsRequiredForSendEmailSteps": "Il modello è necessario per inviare i passaggi di posta elettronica.",
  "body": "Corpo",
  "emailBody": "E-mail corpo...",
  "previewTemplate": "Modello di anteprima",
  "stopOnReply": "Smettere di rispondere",
  "yes": "Sì",
  "no": "No",
  "sMSTemplate": "SMS modello",
  "selectSMSTemplate": "Selezionare SMS modello...",
  "320Characters": "/320 caratteri",
  "duration": "Durata",
  "1Hour": "1 ora",
  "1Day": "1 giorno",
  "2Days": "2 giorni",
  "taskType2": "Tipo di attività",
  "taskTitle2": "Titolo dell'attività",
  "taskTitle3": "Titolo del compito...",
  "dueInMinutes": "Due in minuti",
  "noPropertiesForThisStepType": "Nessuna proprietà per questo tipo di passo.",
  "stepProperties": "Proprietà del passo",
  "wait": "Aspetta.",
  "followUpCall": "Seguire la chiamata",
  "sendSMS": "Invia SMS",
  "pleaseEnterASequenceName": "Inserisci un nome di sequenza",
  "sequenceSaved": "Sequenza salvata",
  "sequenceName": "Nome di sequenza...",
  "sequenceSteps": "Sequenza passi",
  "enrollments": "Iscrizioni",
  "conversion": "Conversione",
  "active": "Attivo",
  "lastModified": "Ultima modifica:",
  "scope": "Ambito:",
  "viewAnalytics": "Visualizza analisi",
  "errorLoadingSequences": "Sequenze di caricamento degli errori",
  "errorDuplicatingSequence": "Sequenza di duplicazione di errore",
  "errorDeletingSequence": "Sequenza di cancellazione di errore",
  "errorLoadingSequenceDetails": "Dettagli della sequenza di caricamento errore",
  "sequenceLibrary": "Biblioteca di successione",
  "createAndManageYourEmailSequences": "Crea e gestisci le tue sequenze di e-mail",
  "createSequence": "Creare Sequenza",
  "searchSequences": "Sequenze di ricerca...",
  "allStatus": "Tutti gli stati",
  "archived": "Archiviato",
  "scope2": "Ambito",
  "allScope": "Tutti gli Scope",
  "loadingSequences": "Sequenze di carico...",
  "noSequencesFound": "Nessuna sequenza trovata",
  "createYourFirstSequence": "Crea la tua prima sequenza",
  "stageChange": "Cambiamento della fase",
  "fieldUpdate": "Aggiornamento del campo",
  "timeBased": "Basato sul tempo",
  "manual": "Manuale",
  "moveStage": "Fase di movimento",
  "updateField": "Aggiornare il campo",
  "addTag2": "Aggiungi il tag",
  "notifyUser": "Informare l'utente",
  "workflowAutomation": "Automazione del flusso di lavoro",
  "createAutomatedWorkflowsToStreamlineYourSalesProcess": "Crea flussi di lavoro automatizzati per semplificare il processo di vendita",
  "createWorkflow": "Crea il flusso di lavoro",
  "deleteWorkflow": "Elimina il flusso di lavoro",
  "areYouSureYouWantToDelete": "Sei sicuro di voler eliminare \"",
  "thisActionCannotBeUndone": "\"? Questa azione non può essere annullata.",
  "delete": "Elimina",
  "trigger": "Grilletto:",
  "actions2": "Azioni:",
  "executions": "Esecuzioni:",
  "noWorkflowsYet": "Nessun flusso di lavoro",
  "createYourFirstWorkflowToAutomateYourSalesProcess": "Crea il tuo primo flusso di lavoro per automatizzare il tuo processo di vendita",
  "createFirstWorkflow": "Crea il primo flusso di lavoro",
  "workflowName": "Nome del flusso di lavoro *",
  "eGNewLeadWelcomeSequence": "ad esempio, Nuova Sequenza di Benvenuto di lead",
  "triggerType": "Tipo di attivazione *",
  "selectTrigger": "Selezionare il trigger",
  "describeWhatThisWorkflowDoes": "Descrivi cosa fa questo flusso di lavoro",
  "addAction": "Aggiungi azione",
  "action": "Azione",
  "actionType": "Tipo di azione",
  "templateNameOrSubject": "Nome del modello o soggetto",
  "taskDescription": "Descrizione delle attività",
  "taskToCreate": "Compito per creare",
  "targetStage": "Obiettivo",
  "noActionsAddedYetClickAddActionToGetStarted": "Non sono ancora state aggiunte azioni. Fare clic su \"Azione Add\" per iniziare.",
  "activateImmediately": "Attivare immediatamente",
  "assigneesUnavailable": "Assignees non disponibile",
  "tasksCanStillBeSavedAsUnassigned": "Le attività possono ancora essere salvate come Unassigned.",
  "leadRequired": "lead richiesto",
  "selectALeadBeforeCreatingATask": "Selezionare un lead prima di creare un'attività.",
  "dueDateRequired": "Data richiesta",
  "selectAValidDueDateAndTime": "Selezionare una data e l'ora di scadenza validi.",
  "taskRescheduled": "Riprogrammazione delle attività",
  "taskCreated": "Compito creato",
  "taskSaveFailed": "Risparmio di attività fallito",
  "planYourNextFollowUp": "Pianifica il tuo prossimo follow-up.",
  "lead2": "lead *",
  "searchByNameEmailPhone": "Ricerca per nome, e-mail, telefono",
  "noResults": "Nessun risultato.",
  "selectLead": "Selezionare il comando",
  "title2": "Titolo *",
  "dueDateTime": "Data e ora *",
  "aM": "AMORE",
  "pM": "PM",
  "saveTask": "Salvare attività",
  "taskWorkspace": "Spazio di lavoro",
  "searchTasksLeads": "Compiti di ricerca, guide",
  "refresh": "Aggiorna",
  "newTask": "+ Nuovo compito",
  "today": "Oggi:",
  "overdue": "In ritardo:",
  "upcoming": "Prossimo:",
  "completed": "Completato:",
  "allAssignees": "Tutti gli assegnatori",
  "loadingTasks": "Caricamento in corso...",
  "noTasksMatchYourFilters": "Nessun compito corrisponde ai filtri.",
  "assigned": "Assegnato",
  "undoCompletion": "Completamento di annullamento",
  "markComplete": "Marcatura completa",
  "taskFocus": "Obiettivo",
  "selectATaskToFocusYourNextAction": "Selezionare un'attività per focalizzare la prossima azione.",
  "relatedLead": "lead collegato",
  "reschedule": "Esecuzione",
  "openLead": "lead aperto",
  "allUnassigned": "Tutti / Non firmati",
  "noPhoneNumber": "Nessun numero di telefono",
  "thisLeadDoesNotHaveAPhoneNumberOnFile": "Questo comando non ha un numero di telefono sul file.",
  "cRMPermissionsAreUnavailable": "I permessi CRM non sono disponibili.",
  "newLead": "Nuovo lead",
  "pipeline3": "Pipeline commerciale:",
  "assignee2": "Assegnatario:",
  "pipelineView": "Vista della tubatura",
  "listView": "Visualizza elenco",
  "failedToLoadCRMPipelines": "Non è riuscito a caricare i gasdotti CRM.",
  "loadingPipeline2": "Conduttura di carico...",
  "loadingInteractions": "Caricamento delle interazioni...",
  "noInteractionsLoggedYet": "Non si sono ancora registrate interazioni.",
  "loggedBy": "Preso da:",
  "active2": "Attivo (",
  "noActiveSequences": "Nessuna sequenza attiva",
  "startSequence": "Avviare la sequenza",
  "someSequencesArePausedOrFailed": "Alcune sequenze sono interrotte o fallite.",
  "nextRun": "Prossima corsa:",
  "failed": "Non sono riuscito:",
  "stageGoal": "Obiettivo della fase",
  "noStageGoalForThisStage": "Nessun obiettivo di fase per questa fase",
  "logInteraction": "Interazione di registro",
  "interactionType": "Tipo di intervento",
  "selectAType": "Seleziona un tipo",
  "phoneCall": "Chiamata telefonica",
  "direction": "Direzione",
  "selectDirection": "Selezionare la direzione",
  "outbound": "In uscita",
  "inbound": "In entrata",
  "occurredAt": "Occurred a",
  "addAnyRelevantNotes": "Aggiungere le note pertinenti",
  "saveInteraction": "Salvare l'interazione",
  "meetingNoteUnavailable": "Nota d'incontro non disponibile",
  "thisInteractionIsMissingAMeetingLink": "Questa interazione manca un link di riunione.",
  "weCouldNotLoadThisMeetingNoteItMayHaveBeenDeletedOrYouMayNotHaveAccess": "Non abbiamo potuto caricare questa nota di riunione. Potrebbe essere stato cancellato o non si può avere accesso.",
  "sequenceStarted": "Sequenza iniziata",
  "failedToStartSequence": "Non è riuscito ad avviare la sequenza",
  "interactionLogged": "Interazione registrata",
  "failedToLogInteraction": "Non riuscito a registrare l'interazione",
  "leadStageUpdated": "Fase di lead aggiornata",
  "failedToUpdateStage": "Non è riuscito ad aggiornare la fase",
  "unableToChangePipeline": "Incapace di cambiare il gasdotto",
  "theSelectedPipelineHasNoOpenStagesAvailable": "L'oleodotto selezionato non ha fasi aperte disponibili.",
  "failedToUpdatePipeline": "Non è riuscito ad aggiornare la pipeline",
  "loadingLead": "Caricamento in corso...",
  "leadNotFound": "lead non trovato.",
  "backToCRM": "Torna a CRM",
  "failedToLoadLead": "Non sono riuscito a caricare lead.",
  "noLeadDataAvailable": "Nessun dato di lead disponibile.",
  "tags2": "Tag:",
  "addTagsSeparatedByCommas": "Aggiungi tag separati da virgole",
  "startSequence2": "Avviare la sequenza",
  "addTask": "Aggiungi attività",
  "viewCompletedTasks": "Visualizza le attività completate",
  "noActiveTasksForThisLead": "Nessun compito attivo per questo vantaggio.",
  "overdue2": "Scaduto",
  "today2": "Oggi",
  "interactions": "Interazioni",
  "logInteraction2": "+ Interazione di registro",
  "failedToLoadInteractions": "Non è riuscito a caricare le interazioni.",
  "leadOverview": "Panoramica dei lead",
  "editLead": "Modificare il comando",
  "loadingConnections": "Collegamenti di carico...",
  "source3": "Fonte:",
  "email2": "E-mail:",
  "phone2": "Telefono:",
  "company2": "Azienda:",
  "leadValue2": "Valore di lead:",
  "assignedTo2": "Assegnato a:",
  "stage3": "Fase:",
  "membershipInterest2": "Interessi di adesione:",
  "interests2": "Interessi:",
  "cRMLead": "Lead CRM",
  "sequence": "Sequenza",
  "chooseASequence": "Scegli una sequenza",
  "startTimeOptional": "Tempo di inizio (opzionale)",
  "start": "Inizio",
  "completedTasks": "Compiti completati",
  "noCompletedTasksForThisLead": "Nessun compito completato per questa guida.",
  "reopen": "Riaprire",
  "moveLeadToThisStage": "Spostare il lead a questa fase?",
  "generatingSuggestions": "Generando suggerimenti...",
  "clickRefreshToGetAIPoweredNextSteps": "Fare clic su aggiornamento per ottenere AI-powered i prossimi passi",
  "generateDraft": "Progetto di generazione",
  "failedToGenerateAISummaryPleaseTryAgain": "Non è riuscito a generare sommario AI. Si prega di riprovare.",
  "justNow": "Solo ora.",
  "selectLeadsToManage": "Selezionare porta a gestire",
  "noPipeline": "Nessun gasdotto",
  "loading": "Caricamento…",
  "calls": "Chiamate",
  "emails": "E-mail",
  "meetings": "Incontri",
  "wonDeals": "Offerte vincenti",
  "slow": "Piano.",
  "fast": "Veloce.",
  "converted": "Convertito",
  "members": "Soci",
  "nA": "N/A",
  "failedToSaveStageAutomation": "Non riuscito a salvare l'automazione delle fasi",
  "failedToRemoveStageAutomation": "Non è riuscito a rimuovere l'automazione delle fasi",
  "failedToSavePipelineStages": "Non è riuscito a salvare le fasi delle tubazioni",
  "failedToDeletePipeline": "Non è riuscito a eliminare il gasdotto",
  "userAssignment": "Assegnazione dell'utente",
  "task": "Compiti",
  "cannotDeleteThisStageBecauseItHasLeadsAssigned": "Non può eliminare questa fase perché ha dei lead assegnati.",
  "closedWonAndClosedLostStagesCannotBeRemoved": "Non è possibile rimuovere le fasi chiuse di Won e Closed Lost.",
  "closedStagesMustBePositionedAtTheEndOfThePipeline": "Gli stadi chiusi devono essere posizionati alla fine del gasdotto.",
  "pipelineMustIncludeExactlyOneClosedWonAndOneClosedLostStage": "La pipelina deve includere esattamente uno Closed Won e uno Closed Lost stage.",
  "pleaseProvideNamesForAllOpenStages": "Si prega di fornire nomi per tutte le fasi aperte.",
  "cannotDeleteAPipelineThatHasLeadsPleaseMoveOrRemoveLeadsFirst": "Non è possibile eliminare una pipeline che ha dei lead. Si prega di spostare o rimuovere i lead prima.",
  "pleaseEnsureThereIsExactlyOneClosedWonAndOneClosedLostStage": "Si prega di assicurarsi che ci sia esattamente uno Closed Won e uno Closed Lost stage.",
  "allActiveStagesNeedAName": "Tutte le fasi attive hanno bisogno di un nome.",
  "areYouSureYouWantToDeleteThisPipeline": "Sei sicuro di voler eliminare questa pipeline?",
  "defineWhoShouldWorkOnTheseLeads": "Definire chi dovrebbe lavorare su queste piste",
  "automaticallyMoveLeadsToTheNextStageOnceTheseGoalsAreMet": "Spostare automaticamente porta alla fase successiva una volta che questi obiettivi sono soddisfatti",
  "createTasksForYourTeamToComplete": "Creare compiti per il tuo team per completare",
  "automaticallySendEmailSequencesToALeadOnceItMovesIntoThisStage": "Invia automaticamente sequenze di e-mail a un lead una volta che si sposta in questa fase",
  "terminal": "Terminali",
  "failedToLoadCRMTarget": "Non è riuscito a caricare il target CRM",
  "failedToCreatePipeline": "Non è riuscito a creare tubazioni",
  "failedToSaveCRMTarget": "Non riuscito a salvare l'obiettivo CRM",
  "noPreviewAvailable": "Nessuna anteprima disponibile",
  "pleaseEnterATemplateName": "Inserisci un nome di modello",
  "editTemplate": "Modifica modello",
  "templateUpdated": "Template aggiornato",
  "templateCreated": "Template creato",
  "areYouSureYouWantToDeleteThisTemplate": "Sei sicuro di voler eliminare questo modello?",
  "notSet": "Non impostato",
  "end": "Fine",
  "pleaseSelectASource": "Si prega di selezionare una fonte.",
  "pleaseSelectAPipelineAndStage": "Si prega di selezionare una pipeline e una fase.",
  "missingClubContext": "Contesto mancante del club.",
  "editLead2": "Modifica",
  "addNewLead": "Aggiungi nuovo lead",
  "selectAMembershipType": "Seleziona un tipo di abbonamento",
  "searchLeadsByNameEmailPhone": "Ricerca conduce per nome, e-mail, telefono",
  "searchMembersByNameEmailPhoneMembership": "Cerca soci per nome, e-mail, telefono, appartenenza #",
  "selectAResult": "Selezionare un risultato",
  "typeAtLeast2CharactersToSearch": "Digitare almeno 2 caratteri per la ricerca",
  "unnamed": "Senza nome",
  "noEmail": "Nessuna e-mail",
  "noContact": "Nessun contatto",
  "unknown": "Sconosciuto",
  "noNote": "Nessuna nota",
  "saving": "Salvataggio…",
  "saveChanges": "Salvare le modifiche",
  "createLead": "Creare lead",
  "noActivity": "Nessuna attività",
  "yourLead": "la tua guida",
  "creating": "Creare...",
  "createMember": "Crea un socio",
  "system": "Sistema",
  "voiceRecognitionIsNotSupportedByYourBrowser": "Il riconoscimento vocale non è supportato dal browser.",
  "failedToLogActivityPleaseTryAgain": "Non è riuscito a registrare l'attività.",
  "pleaseEnterCampaignTitleAndSubject": "Si prega di inserire il titolo della campagna e soggetto",
  "editCampaign": "Modifica della campagna",
  "createEmailCampaign": "Creare una campagna email",
  "updateCampaign": "Campagna di aggiornamento",
  "errorSavingCampaignPleaseTryAgain": "Campagna di salvataggio degli errori. Si prega di riprovare.",
  "errorDuplicatingCampaignPleaseTryAgain": "La campagna di duplicazione degli errori.",
  "errorDeletingCampaignPleaseTryAgain": "Cancellazione degli errori. Si prega di riprovare.",
  "selectProspectsToAddToCRM": "Selezionare le prospettive per aggiungere a CRM",
  "unknownStaff": "Personale sconosciuto",
  "pleaseTryAgain": "Riprova.",
  "inactive": "Inattivo",
  "noPreviewAvailable2": "Nessuna anteprima disponibile.",
  "step": "Passo",
  "errorSavingSequence": "Sequenza di salvataggio degli errori",
  "saving2": "Salvataggio…",
  "areYouSureYouWantToArchiveThisSequence": "Sei sicuro di voler archiviare questa sequenza?",
  "analyticsViewComingSoon": "La vista analitica sta arrivando presto!",
  "pleaseFillInTheRequiredFields": "Si prega di compilare i campi richiesti",
  "errorSavingWorkflowPleaseTryAgain": "Risparmio di errori. Si prega di riprovare.",
  "paused": "In pausa",
  "editWorkflow": "Modifica flusso di lavoro",
  "createNewWorkflow": "Creare un nuovo flusso di lavoro",
  "updateWorkflow": "Aggiorna il flusso di lavoro",
  "meetingNotes": "Note di riunione",
  "manualUI": "UI manuale",
  "noDueDate": "Nessuna scadenza",
  "unknownTime": "Tempo sconosciuto",
  "noSubject": "(Nessun soggetto)",
  "interaction": "Interazione",
  "failed2": "Non riuscito",
  "anErrorOccurredWhileLoggingTheInteraction": "Si è verificato un errore durante la registrazione dell'interazione.",
  "failedToLoadTasks": "Non riuscita a caricare le attività",
  "updatingLeadPipeline": "Aggiornamento della pipeline di lead",
  "noNotesYet": "Non ci sono ancora note.",
  "upcoming2": "Prossimo",
  "completed2": "Completato",
  "all": "Tutti",
  "noLeadAssociated": "Nessun lead associato",
  "noDescription": "Nessuna descrizione",
  "unnamedLead": "Lead senza nome",
  "teamMember": "Membro del team",
  "assignedUser": "utente assegnato",
  "rescheduleTask": "Attività di riprogrammazione",
  "receivedEmail": "Ricevi via email",
  "receivedSMS": "Ricevuto SMS",
  "receivedEmailOrSMS": "Ricevi via email o SMS",
  "taskCompleted": "Compito completato",
  "draft": "Bozza",
  "cancelled": "Annullato",
  "pending": "In attesa",
  "scheduled2": "Programmato",
  "skipped": "Ignorato",
  "running": "Esecuzione",
  "readOnly": "Leggi solo",
  "unableToCompleteThisActionPleaseTryAgain": "Incapace di completare questa azione. Si prega di riprovare.",
  "taskMovedToDate": "Il compito si è spostato a {date} .",
  "scheduledForDate": "Programmato per {date} .",
  "movedCountLeadSToPipeline": "Spostato {count} lead (s) a {pipeline}",
  "addedCountProspectSToCRM": "Aggiunto {count} prospettiva (s) a CRM",
  "revertedCountLeadSBackToProspects": "Revertito {count} lead(i) indietro a prospettive",
  "sendEmailStepStepRequiresAnEmailTemplate": "Invia Email step {step} richiede un modello di e-mail",
  "deleteName": "Elimina {name}?",
  "editName": "Modifica di {name}",
  "duplicateName": "Duplica {name}",
  "archiveName": "Archivio {name}",
  "selectName": "Seleziona {name}",
  "moveName": "Spostamento {name}",
  "firstName2": "Nome",
  "lastName2": "Cognome",
  "senderName2": "Nome del fornitore",
  "companyName": "Nome della Società",
  "notAuthorised": "Non autorizzato",
  "youDoNotHavePermissionToPerformThisAction": "Non hai il permesso di eseguire questa azione.",
  "pause": "Pausa",
  "resume": "Ripresa",
  "dragCancelled": "Drag annullato.",
  "liftedItemAtPositionPositionUseArrowKeysToMoveSpaceToDropOrEscapeToCancel": "Elemento sollevato in posizione {position} . Utilizzare i tasti freccia per muoversi, Spazio per cadere, o Escape per annullare.",
  "movingToPositionPosition": "Spostarsi nella posizione {position} .",
  "droppedAtPositionPosition": "Caduta in posizione {position} .",
  "pressSpaceToPickUpAnItemUseArrowKeysToMoveItSpaceToDropOrEscapeToCancel": "Premere lo spazio per raccogliere un elemento. Utilizzare i tasti freccia per spostarlo, Spazio per cadere, o Escape per annullare.",
  "startDate": "Data di inizio",
  "duplicate": "Duplicare",
  "archive": "Archivia",
  "selectAll": "Seleziona tutto",
  "selectProspect": "Selezionare la prospettiva",
  "noDataAvailable": "Nessun dato disponibile",
  "errorGeneratingEmailDraftPleaseTryAgain": "Errore che genera la bozza di e-mail. Si prega di riprovare.",
  "open": "Apri",
  "countHoursAgo": "{count} ore fa",
  "countDaysAgo": "{count} giorni fa",
  "generateInsights": "Generare le visioni",
  "thisLeadHasAlreadyBeenConverted": "Questa pista è già stata convertita.",
  "aMemberWithTheseContactDetailsAlreadyExists": "Esiste già un socio con questi dati di contatto.",
  "selectAStageInTheSelectedPipeline": "Selezionare una fase della pipeline selezionata.",
  "chooseAnActiveSalesTeamMember": "Scegli un membro del team di vendita attivo.",
  "thereIsNoImportToUndo": "Non c'è importazione da annullare.",
  "taskTypeAndNameAreRequired": "Tipo di attività e nome sono necessari.",
  "sequenceHasNoStepsAddStepsBeforeEnrollingLeads": "Sequenza non ha passi. Aggiungere i passaggi prima di iscriversi conduce.",
  "sequenceIsArchivedActivateItBeforeEnrollingLeads": "Sequenza è archiviata. Attivalo prima di iscrivere i cavi.",
  "theSequenceMustBeActiveBeforeEnrollingLeads": "La sequenza deve essere attiva prima di iscriversi alla guida.",
  "sequenceNotFound": "Sequenza non trovata.",
  "pipelineNotFound": "Pipeline non trovata.",
  "taskNotFound": "Compito non trovato.",
  "checkTheRequiredFieldsAndTryAgain": "Controllare i campi richiesti e riprovare.",
  "selectAValidStage": "Selezionare una fase valida.",
  "enterAnAIPrompt": "Inserire un prompt AI.",
  "chooseEmailOrSMS": "Scegliere Email o SMS .",
  "golfVisitorLog": "Log dei visitatori di golf",
  "racquetVisitorLog": "Log di visitatori racchetta",
  "spaVisitorLog": "Log dei visitatori di Spa",
  "fitnessVisitorLog": "Registrazione dei visitatori di Fitness",
  "diningVisitorLog": "Log dei visitatori del ristorante",
  "visitorLog": "Log dei visitatori",
  "settingsLeads": "lead",
  "settingsRedesign0": "Impostazioni CRM",
  "settingsRedesign1": "Gestisci il tuo team di vendita, condutture e obiettivi.",
  "settingsRedesign2": "Squadre di vendita",
  "settingsRedesign3": "Aggiungere il personale esistente e dare loro un ruolo CRM. Questo non cambia il loro titolo di lavoro o l'accesso al club.",
  "settingsRedesign4": "Aggiungere il personale",
  "settingsRedesign5": "Ricerca per nome del personale",
  "settingsRedesign6": "Filtro rotativo",
  "settingsRedesign7": "Tutti i ruoli",
  "settingsRedesign8": "Responsabili commerciali",
  "settingsRedesign9": "Punti vendita",
  "settingsRedesign10": "Responsabile vendite",
  "settingsRedesign12": "Tutti i compiti del club CRM",
  "settingsRedesign13": "Solo compiti assegnati",
  "settingsRedesign14": "Ruolo CRM",
  "settingsRedesign15": "risultati",
  "settingsRedesign16": "Cancella filtri",
  "settingsRedesign17": "Riprova",
  "settingsRedesign18": "Non c'e' personale corrispondente.",
  "settingsRedesign19": "Ruolo sconosciuto",
  "settingsRedesign20": "Cambiare il ruolo di CRM",
  "settingsRedesign21": "Questa persona otterrà l'accesso a tutte le attività del club CRM.",
  "settingsRedesign22": "Questa persona sarà in grado di visualizzare solo i loro compiti assegnati.",
  "settingsRedesign23": "Applicare il ruolo",
  "settingsRedesign24": "Azioni di personale",
  "settingsRedesign25": "Riassegnare il lavoro",
  "settingsRedesign26": "Rimuovere dal team di vendita",
  "settingsRedesign27": "Aggiungi il personale selezionato",
  "settingsRedesign28": "Riassegnare e rimuovere",
  "settingsRedesign29": "Ricerca personale",
  "settingsRedesign30": "Nome di ricerca, titolo di reparto o di lavoro",
  "settingsRedesign31": "personale selezionato",
  "settingsRedesign32": "Già aggiunto",
  "settingsRedesign33": "Identità autenticata esistente richiesta",
  "settingsRedesign34": "Caricamento personale...",
  "settingsRedesign35": "attività aperte",
  "settingsRedesign36": "piste attive",
  "settingsRedesign37": "Caricamento in corso...",
  "settingsRedesign38": "Il loro record personale e la storia completa del lavoro rimangono. Il lavoro aperto deve essere trasferito prima della rimozione.",
  "settingsRedesign39": "Ricerca personale di destinazione",
  "settingsRedesign40": "Nuovo assegnatore di attività",
  "settingsRedesign41": "Nuovo proprietario di lead",
  "settingsRedesign42": "Selezionare la destinazione",
  "settingsRedesign43": "Includere la proprietà attiva del lead",
  "settingsRedesign44": "Le attività completate e i cavi chiusi non saranno cambiati.",
  "settingsRedesign45": "Anteprima Refresh",
  "settingsRedesign46": "Selezionare il personale per continuare.",
  "settingsRedesign47": "Regole di attività",
  "settingsRedesign48": "I manager vedono tutti i compiti del club CRM. I venditori vedono solo i propri. I compiti non assegnati sono visibili ai manager.",
  "settingsRedesign49": "Gestisci le regole",
  "settingsRedesign50": "Salvare le regole",
  "settingsRedesign51": "Visibilità del compito",
  "settingsRedesign52": "Risolto dal ruolo",
  "settingsRedesign53": "Assegnazione di default",
  "settingsRedesign54": "Proprietario predefinito di nuove attività",
  "settingsRedesign55": "Creatore di attività",
  "settingsRedesign56": "Proprietario principale",
  "settingsRedesign57": "Responsabile di riserva",
  "settingsRedesign58": "Unassigned — visibile ai manager",
  "settingsRedesign59": "Nuove attività utilizzano il creatore di attività idoneo. Altrimenti rimangono senza firma.",
  "settingsRedesign60": "Le nuove attività utilizzano il proprietario di lead idoneo, poi il manager fallback. Senza di esse, rimangono senza firma.",
  "settingsRedesign61": "I default si applicano solo alle nuove attività. Sono conservati incarichi esistenti e assegnazioni autorizzate esplicite. I venditori possono creare solo compiti per se stessi.",
  "settingsRedesign62": "Salva le modifiche",
  "settingsRedesign64": "Cambiamenti non rilevati",
  "settingsRedesign65": "Salvare le modifiche prima di chiudere?",
  "settingsRedesign66": "Continua a modificare",
  "settingsRedesign67": "Disattivare le modifiche",
  "settingsRedesign68": "Obiettivi",
  "settingsRedesign69": "Inserire un obiettivo di numero intero positivo.",
  "settingsRedesign70": "L'etichetta è richiesta.",
  "settingsRedesign71": "Modifica della pipeline",
  "settingsRedesign72": "Creare pipeline",
  "settingsRedesign73": "Risparmio di gasdotti",
  "settingsRedesign74": "Ordine ordinario",
  "settingsRedesign75": "Fornire nomi di fase unici, un nome di pipeline e un ordine valido.",
  "settingsRedesign76": "Nome della fase",
  "settingsRedesign77": "Colore della fase",
  "settingsRedesign78": "Esito di fase",
  "settingsRedesign79": "Voce",
  "settingsRedesign80": "Perdita",
  "settingsRedesign81": "Spostare il palco",
  "settingsRedesign82": "Spostare la fase in giù",
  "settingsRedesign83": "Rimuovere la fase",
  "settingsRedesign84": "I risultati con i record esistenti non possono essere modificati. Spostare i record in una fase con lo stesso risultato prima di rimuoverlo.",
  "settingsRedesign85": "Le prospettive devono muoversi prima che questa fase possa essere rimossa.",
  "settingsRedesign86": "Fase di destinazione",
  "settingsRedesign87": "Tenere la fase",
  "settingsRedesign88": "Anteprima Pipeline",
  "settingsRedesign89": "Tenere un Won e uno stadio perso alla fine. Trascinare le fasi o utilizzare i pulsanti freccia per riordinare.",
  "settingsRedesign90": "Salvataggio",
  "settingsRedesign93": "I tuoi cambiamenti sono stanti. Aggiornare l'anteprima e rivedere il lavoro aggiornato prima di confermare.",
  "settingsRedesign94": "Questo record è cambiato. Chiudi e riaprire l'editor prima di provare di nuovo.",
  "settingsRedesign95": "Scegli prima un manager di fallback sostitutivo nelle regole del Task.",
  "settingsRedesign96": "Personale eleggibilità cambiato. Rifiutare il raccoglitore del personale e rivedere la vostra selezione.",
  "settingsRedesign97": "Alcuni collaboratori selezionati sono già nel team di vendita. Rifiutare e riprovare.",
  "settingsRedesign98": "Scegli una destinazione idonea per ogni tipo di lavoro aperto.",
  "settingsRedesign99": "I record esistenti impediscono di cambiare questo risultato. Mantenere l'esito per preservare la segnalazione.",
  "settingsRedesign100": "Scegli una fase di destinazione in questa pipeline con lo stesso risultato.",
  "settingsRedesign101": "I permessi CRM non sono disponibili. Si prega di riprovare.",
  "settingsStageAutomations": "Automazioni sceniche",
  "settingsUnableToLoadSettings": "Non è possibile caricare le impostazioni.",
  "settingsChangesNotSaved": "Modifiche non salvate",
  "settingsAddCountStaff": "Aggiungi {count} personale",
  "settingsReplacementFallbackManager": "Sostituzione fallback manager",
  "settingsStageAssignmentDefaultsWillAlsoTransferToTheNewLeadOwner": "di default di assegnazione di fase si trasferirà anche al nuovo proprietario di lead.",
  "settingsUseAssignmentDefault": "Utilizzare l'assegnazione predefinita",
  "settingsNoTaskAccess": "Nessun accesso alle attività",
  "settingsNoEligibleStaffAreAvailable": "Non sono disponibili personale idoneo."
}
